module.exports = __webpack_public_path__ + "static/media/logo_facial.62ded847.png";